import { colors } from 'constants/colors';

export const DEFAULT_GRAPH_DIMENSIONS = {
  width: 352,
  height: 270,
  padding: 40,
  hoverStrokeWidth: 5,
};

const graphHorizontalMargin = 85;

export const BUBBLES = {
  fillOpacity: 0.4,
  fillOpacityActive: 1,
  fill: colors.ayPearGreenColor,
  strokeWidth: 12,
  strokeWidthOuter: 20,
};

export const TOOLTIP_LINE_STROKE = 2;

interface IXCoordinate {
  [key: string]: number;
}

export const XCoordinates: IXCoordinate = {
  left: graphHorizontalMargin,
  middle: DEFAULT_GRAPH_DIMENSIONS.width / 2,
  right: DEFAULT_GRAPH_DIMENSIONS.width - graphHorizontalMargin,
  'close-right': DEFAULT_GRAPH_DIMENSIONS.width / 2 + 32,
};

export const getBubbleId = (position: string) => `bubble-${position}`;
export const TIMELINE_GRAPH_ID = 'timeline-svg';
export const TIMELINE_CENTER_LINE_ID = 'center-line';
export const TIMELINE_HORIZONTAL_LINE_ID = 'horizontal-line';
export const TIMELINE_GREEN_TOOLTIP_LINE_ID = 'green-tooltip-line';

export const getLinePositionId = (position: string) =>
  `line-position-${position}`;
export const getOuterElementPositionId = (position: string) =>
  `outer-element-${position}`;

export enum TimeLineBubbleIds {
  GREEN,
  PURPLE_1,
  PURPLE_2,
}
